import { render, staticRenderFns } from "./EditHolidayPage.vue?vue&type=template&id=f99d9f88&"
import script from "./EditHolidayPage.vue?vue&type=script&lang=js&"
export * from "./EditHolidayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports